const initialState = {
  supplierDetails: {},
  allSupplierDetails: [],
  taxIdentifierDetails: {}
};

const BackofficeServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SUPPLIER_DETAILS':
      return {
        ...state,
        supplierDetails: action.payload
      };
    case 'SET_ALL_SUPPLIER_DETAILS':
      return {
        ...state,
        allSupplierDetails: action.payload
      };
    case 'SET_TAX_IDENTIFIER':
      return {
        ...state,
        taxIdentifierDetails: action.payload
      };
    default:
      return state;
  }
};

export default BackofficeServiceReducer;
